import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TabPanel, Tabs } from '@/components';
import { MyJobsProvider } from '@/hoc/context/my-jobs-context';
import { MyJobsList } from './my-jobs-list';
export var ManageMyJobs = function (_a) {
    var isPreview = _a.isPreview;
    var tabs = [
        {
            label: 'All',
        },
        {
            label: 'Saved Jobs',
        },
        {
            label: 'Applied Jobs',
        },
    ];
    return (_jsx("div", { className: 'flex flex-col gap-4 text-sm md:text-base lg:text-lg p-3 vjwMd:p-4 pt-0', children: _jsxs(Tabs, { tabs: tabs, variant: 'solid', tabsClassName: 'justify-center', children: [_jsx(TabPanel, { className: 'px-4 py-2', children: _jsx(MyJobsProvider, { children: _jsx(MyJobsList, { isPreview: isPreview }) }) }), _jsx(TabPanel, { className: 'px-4 py-2', children: _jsx(MyJobsProvider, { isSaved: true, children: _jsx(MyJobsList, { isPreview: isPreview }) }) }), _jsx(TabPanel, { className: 'px-4 py-2', children: _jsx(MyJobsProvider, { isApplied: true, children: _jsx(MyJobsList, { isPreview: isPreview }) }) })] }) }));
};
